import React, { Component } from "react";
import PropTypes from "prop-types";
import ConfirmModal from "./ConfirmModal";
import IconButton from "@material-ui/core/IconButton";
import PublishIcon from "@material-ui/icons/Publish";

class Publish extends Component {
  state = {
    showPublishModal: false
  };

  publishModal = () => {
    this.setState({ showPublishModal: true });
  };

  handlePublish = () => {
    const { publish } = this.props;

    this.setState({ showPublishModal: false });
    publish();
  };

  handleCancelPublish = () => {
    this.setState({ showPublishModal: false });
  };

  render() {
    const { title, message } = this.props;

    return (
      <>
        <IconButton color="inherit" onClick={this.publishModal}>
          <PublishIcon />
        </IconButton>
        {this.state.showPublishModal && (
          <ConfirmModal
            title={title}
            message={message}
            handleOk={this.handlePublish}
            handleCancel={this.handleCancelPublish}
          />
        )}
      </>
    );
  }
}

Publish.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  publish: PropTypes.func.isRequired
};

export default Publish;
